module.exports = __webpack_public_path__ + "img/eg-other-03.ac3e81a0.png";